export default __webpack_public_path__ + "static/845-8db4029ac2df9195e954969b99f223b1.gif";